export default __webpack_public_path__ + "static/media/rack_card_portrait_4x9in.4d6e6c7a.png";